import styled from 'styled-components';

export const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.6rem;
  padding: 0.8rem;
  margin-bottom: 2.4rem;
`;
export const ChartTab = styled.div`
  width: 100%;
  display: flex;
  margin-top: 4rem;
`;

export const Tab = styled.div<{ isSelected: boolean }>`
  border-radius: 0.8rem;
  text-align: center;
  padding: 0.8rem 1.2rem;
  font-size: 1.4rem;
  width: 50%;

  color: ${props => (props.isSelected ? 'var(--color-white)' : '#5c576b')};
  background-color: ${props => (props.isSelected ? '#2e2b36' : '#1f1e25')};
`;

export const ComparisonBox = styled.div`
  width: 100%;
  display: flex;
  gap: 0.8rem;
  height: 18rem;
`;

export const ImgBox = styled.div`
  width: 100%;
  position: relative;
  object-fit: cover;
  & > img {
    border-radius: 0.8rem;
    width: 100%;
    height: 100%;
    position: absolute;
  }
  & > p {
    position: absolute;
    font-size: 1.3rem;
    line-height: 1.8rem;
    padding: 0.5rem 0.8rem;
  }
  & > .Before {
    width: 2.8rem;
    height: 2.8rem;
    bottom: 0;
    left: 0;
    background-color: #2e2b36;
    border-radius: 0 0.8rem 0 0.8rem;
  }
  & > .After {
    width: 2.8rem;
    height: 2.8rem;
    bottom: 0;
    right: 0;
    background-color: var(--color-point);
    border-radius: 0.8rem 0 0.8rem 0;
  }
`;

export const ItemBox = styled.div`
  width: 12rem;
  height: 18rem;
  flex: none;
  display: flex;
  gap: 0.8rem;
  flex-direction: column;
  align-items: center;
  & > img {
    width: 100%;
    height: 15.4rem;
  }
  & > p {
    font-size: 1.3rem;
    color: #8e899f;
    line-height: 1.8rem;
    font-weight: 400;
  }
`;

export const HistoryBox = styled.div`
  width: 100%;
  display: flex;
  gap: 0.8rem;
  overflow-x: scroll;
`;
